/**
* 基础菜单 营销管理 专属商城管理 设置商城商品
*/
<template>
  <div class="contianer">
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="formInline.standard_code" placeholder="松佰标准编码" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.seller_name" placeholder="发货商家" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.sale_name" placeholder="销售名称" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.product_code" placeholder="商品编码" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="formInline.product_type" placeholder="商品类型" clearable>
          <el-option label="自营" value="0"></el-option>
          <el-option label="供货商代发" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">查询</el-button>
        <el-button size="small" type="success" @click="adddiscount">新增</el-button>
        <el-button size="small" type="info" @click="editdiscount">修改</el-button>
        <el-button size="small" type="danger" @click="deldiscount">删除</el-button>
        <el-button size="small" type="warning" plain @click="batch">批量导入商城商品</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div style="height: 530px;overflow-y: auto">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                @cell-dblclick="cellDbClick" @selection-change="handleSelectionChange"
                :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column
          label="序号"
          width="60">
          <template slot-scope="scope">
            {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
          </template>
        </el-table-column>
        <el-table-column prop="activity_area_sort_name" label="商城分类名称" min-width="150" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="seller_name" label="供货商名称" width="150" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="sale_name" label="销售名称" width="150" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="product_code" label="商品编码" width="150" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="standard_code" label="松佰商品标准编码/供应商商品编码" width="220" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="uuid" label="UUID" width="100" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="pack_unit" label="包装单位" width="100" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="unit_number" label="销售系数" width="100" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="zone_sale_name" label="专区展示名称" width="120" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="activity_area_sale_price" label="专区销售价" width="120" :show-overflow-tooltip='true'>
          <template slot-scope="scope">
            <div v-if="scope.row.activity_area_sale_price||scope.row.activity_area_sale_price==0">￥{{scope.row.activity_area_sale_price}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="saled_num" label="销量" width="100" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="available_stock" label="库存" width="100" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="putaway_status" label="上架状态" width="100" :show-overflow-tooltip='true'>
          <template slot-scope="scope">
            <div plain style="color: red;" v-if="scope.row.putaway_status=='76'">下架</div>
            <div plain style="color: #409eff;" v-else-if="scope.row.putaway_status=='75'">上架</div>
            <div plain v-else></div>
          </template>
        </el-table-column>
        <el-table-column prop="seq" label="排序号" width="100" :show-overflow-tooltip='true'>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               :title="dialogTitle"
               :visible.sync="infoDialogVisible"
               width="30%"
               :before-close="handleClose"
               center>
      <el-form label-width="155px" :model="flashForm" :rules="rules" ref="flashForm" class="flashForm">
        <el-form-item label="发货类型" prop="product_type" class="relative">
          <el-select v-model="flashForm.product_type" placeholder="请选择发货类型" clearable :disabled="isDisabled"
                     @change="changeSendMode">
            <el-option v-for="status in typeList" :key="status.value" :label="status.name"
                       :value="status.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品名称" prop="product_sale_name" v-if="flashForm.product_type==0">
          <div style="display: flex;">
            <el-input v-model="flashForm.product_sale_name" auto-complete="off" clearable placeholder="请选择商品" disabled>
            </el-input>
            <el-button size="small" type="success" style="margin-left: 5px" @click="querySearch">查询</el-button>
          </div>
        </el-form-item>
        <el-form-item label="供应商名称" prop="seller_supplier_id" class="relative" v-if="flashForm.product_type==1">
          <el-select v-model="flashForm.seller_supplier_id" placeholder="请选择供应商名称" clearable :disabled="isDisabled"
                     @change="changeProductName(flashForm.seller_supplier_id)">
            <el-option v-for="seller in supplierList" :key="seller.seller_supplier_id" :label="seller.seller_supplier_name"
                       :value="seller.seller_supplier_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品销售名称" prop="supplier_product_name" v-if="flashForm.product_type==1">
          <div style="display: flex;">
            <el-input v-model="flashForm.supplier_product_name" auto-complete="off" clearable placeholder="请选择商品" disabled>
            </el-input>
            <el-button size="small" type="success" style="margin-left: 5px" @click="supplierSearch">查询</el-button>
          </div>
        </el-form-item>
        <el-form-item label="供货价" prop="supplier_price" v-if="flashForm.product_type==1">
          <el-input v-model="flashForm.supplier_price" auto-complete="off" clearable placeholder="请选择供货价" disabled>
          </el-input>
        </el-form-item>
        <el-form-item label="商城分类" prop="activity_area_sort_id" class="relative">
          <el-select v-model="flashForm.activity_area_sort_id" filterable placeholder="请选择商城分类" clearable
                     remote :filter-method="remoteMethod" class="productInterval" :popper-append-to-body="false"
                     @focus="focusLabelName()" @change="changeLabelName(flashForm.activity_area_sort_id)" @clear="clear()">
            <el-option
              v-for="item in tionList"
              :key="item.id"
              :label="item.area_sort_name"
              :value="item.id">
            </el-option>
            <div class="pagination-absolute">
              <el-pagination :small="small" style="height: 30px;margin-top: 8px"
                             @size-change="labelHandleSizeChange"
                             @current-change="labelHandleCurrentChange"
                             :current-page.sync="labelCurrentPage"
                             :page-size="labelPagesize"
                             layout="total, prev, pager, next"
                             :total="labelTotalSize">
              </el-pagination>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="排序号" prop="seq">
          <el-input v-model="flashForm.seq" auto-complete="off" clearable placeholder="请输入排序号" maxlength="10">
          </el-input>
        </el-form-item>
        <el-form-item label="专区展示名称" prop="sale_name">
          <el-input v-model="flashForm.sale_name" auto-complete="off" maxlength="150" clearable placeholder="请输入专区展示名称">
          </el-input>
        </el-form-item>
        <el-form-item label="专区编码" prop="activity_area_code">
          <el-input v-model="flashForm.activity_area_code" auto-complete="off" maxlength="30" clearable placeholder="请输入专区编码">
          </el-input>
        </el-form-item>
        <el-form-item label="是否自负盈亏" prop="is_self_supporting" class="relative" v-if="this.flashForm.product_type == '1'">
          <el-select v-model="flashForm.is_self_supporting" placeholder="请选择是否自负盈亏" clearable>
            <el-option v-for="status in isselfList" :key="status.value" :label="status.name"
                       :value="status.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="专区销售价" prop="activity_area_sale_price" v-if="this.flashForm.product_type == '0' || this.flashForm.is_self_supporting == '1'">
          <el-input v-model="flashForm.activity_area_sale_price" auto-complete="off" maxlength="8" clearable placeholder="请输入专区销售价" onkeyup="if(isNaN(value))execCommand('undo')" onafterpaste="if(isNaN(value))execCommand('undo')">
          </el-input>
        </el-form-item>
        <el-form-item class="form-item-with-asterisk" label="专区销售价" prop="activity_area_sale_price" :rules="activityAreaSalePriceRules" v-else>
          <el-input v-model="flashForm.activity_area_sale_price" auto-complete="off" maxlength="8" clearable placeholder="请输入专区销售价" onkeyup="if(isNaN(value))execCommand('undo')" onafterpaste="if(isNaN(value))execCommand('undo')">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="saveSort('flashForm')" :disabled="!isCanSubmit">确 认</el-button>
            <el-button @click="handleClose()">取 消</el-button>
      </span>
    </el-dialog>

<!--    选择商品-->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               title="选择商品"
               :visible.sync="productDialogVisible"
               width="40%"
               top="6vh"
               :before-close="prodHandleClose"
               center>
      <!--列表-->
      <div style="height: 530px;overflow-y: auto">
        <el-form :inline="true" :model="productFormInline" class="user-search">
          <el-form-item label="">
            <el-input size="small" v-model="productFormInline.sale_name" placeholder="商品销售名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input size="small" v-model="productFormInline.product_code" placeholder="松佰商品标准编码/供应商商品编码" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="productSearch">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table size="small" :data="productListData" highlight-current-row v-loading="loading" border
                  @cell-dblclick="cellDbClick" @selection-change="infoHandleSelectionChange"
                  :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                  element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column align="center" type="selection" width="60">
          </el-table-column>
          <el-table-column
            label="序号"
            width="60">
            <template slot-scope="scope">
              {{productpageparm.pageSize * (productpageparm.currentPage - 1) + (scope.$index + 1)}}
            </template>
          </el-table-column>
          <el-table-column prop="sale_name" label="商品销售名称" min-width="220" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="product_code" label="松佰商品标准编码/供应商商品编码" min-width="220" :show-overflow-tooltip='true'>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="productpageparm" @callFather="productCallFather"></Pagination>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sureRonous()">确 认</el-button>
        <el-button @click="prodHandleClose()">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 供应商-选择商品-->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               title="选择商品"
               :visible.sync="productDialogVisible1"
               width="40%"
               top="6vh"
               :before-close="prodHandleClose1"
               center>
      <!--列表-->
      <div style="height: 530px;overflow-y: auto">
        <el-form :inline="true" :model="productFormInline1" class="user-search">
          <el-form-item label="">
            <el-input size="small" v-model="productFormInline1.sale_name" placeholder="商品销售名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input size="small" v-model="productFormInline1.product_code" placeholder="松佰商品标准编码/供应商商品编码" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="productSearch1">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table size="small" :data="productListData1" highlight-current-row v-loading="loading" border
                  @cell-dblclick="cellDbClick" @selection-change="infoHandleSelectionChange1"
                  :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                  element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column align="center" type="selection" width="60">
          </el-table-column>
          <el-table-column
            label="序号"
            width="60">
            <template slot-scope="scope">
              {{productpageparm1.pageSize * (productpageparm1.currentPage - 1) + (scope.$index + 1)}}
            </template>
          </el-table-column>
          <el-table-column prop="sale_name" label="商品销售名称" min-width="220" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="product_code" label="松佰商品标准编码/供应商商品编码" min-width="220" :show-overflow-tooltip='true'>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="productpageparm1" @callFather="productCallFather1"></Pagination>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sureRonous1()">确 认</el-button>
        <el-button @click="prodHandleClose1()">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 批量导入上架信息-->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               title="批量导入商城商品" :before-close="batchHandleClose"
               :visible.sync="batchDialogVisible"
               width="40%"
               top="6vh"
               center>
      <!-- 上传excel文件-->
      <div class="zipFile">
        <div style="width: 200px;height: 150px">
          <el-upload :http-request="uploadFile"
                     ref="excelLoad"
                     action="#"
                     :before-upload="excelBeforeUpload"
                     :limit="1"
                     :auto-upload="true">
            <div class="icon-container">
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </div>
          </el-upload>
        </div>
        <div class="prompt">请在下载的模板中填入基础信息后在此处上传</div>
      </div>
      <div style="text-align: center;margin: 10px 0;">
        <el-button size="small" type="primary" :loading="loading" @click="confirmImport" :disabled="!isCanSubmit">确认导入</el-button>
        <el-button size="small" :loading="loading" @click="download">下载模版</el-button>
      </div>
      <!--列表-->
      <div class="importLog">导入日志</div>
      <div style="height: 300px;overflow-y: auto">
        <el-table size="small" :data="batchlistData" highlight-current-row v-loading="loading" border
                  @cell-dblclick="cellDbClick"
                  :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                  element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column
            type="index"
            label="序号"
            width="60">
            <template slot-scope="scope">
              {{batchpageparm.pageSize * (batchpageparm.currentPage - 1) + (scope.$index + 1)}}
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="导入时间" width="150" :show-overflow-tooltip='true'>
            <template slot-scope="scope">
              <div>{{scope.row.create_time|timestampToTime}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="file_name" label="文件名称" min-width="150" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="status" label="导入结果" width="120" :show-overflow-tooltip='true'>
            <template slot-scope="scope">
              <div plain v-if="scope.row.status=='0'">处理中</div>
              <div plain v-else-if="scope.row.status=='1'">处理成功</div>
              <div plain v-else>处理失败</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="120">
            <template slot-scope="scope">
              <el-button type="primary" plain size="mini" v-if="scope.row.status != '0'"
                         @click="results(scope.row.file_id, scope.row.error_message, scope.row.status, scope.row.total_fail, scope.row.total_success, scope.row.total_fail)"
                         style="width: 80px">查看结果
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="batchpageparm" @callFather="importFather"></Pagination>
    </el-dialog>

    <!--导入结果-->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               title="导入结果"
               :visible.sync="resultsDialogVisible"
               width="40%"
               top="15vh"
               center>
      <!--列表-->
      <div v-if="importWas">
        <div class="importtion">
          <span class="colorec808d">{{ total_fail }}</span>条数据导入失败
        </div>
        <div style="height: 300px;overflow-y: auto">
          <el-table size="small" :data="resultslistData" highlight-current-row v-loading="loading" border
                    @cell-dblclick="cellDbClick"
                    :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                    element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column
              label="序号"
              width="60">
              <template slot-scope="scope">
                {{resultsPageparm.pageSize * (resultsPageparm.currentPage - 1) + (scope.$index + 1)}}
              </template>
            </el-table-column>
            <el-table-column prop="product_code" label="商品编码" min-width="150" :show-overflow-tooltip='true'>
            </el-table-column>
            <el-table-column prop="error_message" label="失败原因" min-width="200" :show-overflow-tooltip='true'>
              <template slot-scope="scope">
                <span class="colord9001b">{{ scope.row.error_message }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="resultsPageparm" @callFather="resultscallFather"></Pagination>
        <div slot="footer" class="dialog-footer textCenter">
          <el-button type="primary" @click="resultsDialogVisible = false">确 认</el-button>
        </div>
      </div>
      <div class="textCenter" v-if="totalFail">
        <div class="resultent">
          已全部成功导入
        </div>
        <div style="margin-top: 20px">
          <el-button type="primary" @click.capture="resultsDialogVisible = false">确 认</el-button>
        </div>
      </div>
      <div class="textCenter" v-if="importFailed">
        <div class="resultent">{{ this.errorMessage }}</div>
        <div style="margin-top: 20px">
          <el-button type="primary" @click.capture="resultsDialogVisible = false">确 认</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  itemsList,
  itemsAdd,
  itemsUpdate,
  itemsProductList,
  itemsDetail,
  itemsDelete,
  areaSortList,
  purchaserSupplierList,
  supplyProductList,
  custInfo,
  batchImportLogsList,
  itemsBatchImport,
  batchExport,
  batchImportLogsDetailList
} from '../../api/basisMG'
  import Pagination from '../../components/Pagination'
  import {uploadFile} from '../../utils/util'

  export default {
    data: () => {
      var validateNum = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入排序号'));
        } else if (!(/(^[1-9]\d*$)/.test(value))) {
          return callback(new Error('请输入正整数'));
        } else {
          return callback();
        }
      };
      return {
        loading: false, //是显示加载
        infoDialogVisible: false,  // 弹窗
        productDialogVisible: false,
        productDialogVisible1: false,
        batchDialogVisible: false,
        dialogTitle: '',  // 标题
        selectTableData: [],
        infoSelectTableData: [],
        productId: '',
        productListData: [],
        productListData1: [],
        formInline: {
          page: 1,
          rows: 10,
          standard_code: "",
          seller_name: "",
          product_type: "",
          activity_area_id: "",
          activity_area_sort_id: "",
          product_code: "",
          sale_name: ""
        },
        flashForm: {
          id: "",
          activity_area_id: "",
          activity_area_sort_id: "",
          activity_area_sort_name: "",
          seq: "",
          sale_name: "",
          sale_id: "",
          zone_sale_name: "",
          activity_area_code: "",
          activity_area_sale_price: "",
          product_type: "",
          seller_name: "",
          product_sale_name: "",
          seller_supplier_id: "",
          supplier_product_name: "",
          supplier_price: "",
          seller_supplier_product_id: "",
          is_self_supporting: ""
        },
        productFormInline: {
          page: 1,
          rows: 10,
          product_code: "",
          sale_id: "",
          sale_name: "",
          activity_area_sort_id: ""
        },
        productFormInline1: {
          page: 1,
          rows: 10,
          product_code: "",
          sale_name: "",
          activity_area_sort_id: "",
          supplier_seller_id: "",
          supplier_price: "",
          status: 1
        },
        rules: {
          product_type: [{required: true, message: '请选择发货类型', trigger: 'change'}],
          activity_area_sort_id: [{required: true, message: '请选择商城分类', trigger: 'change'}],
          // seller_name: [{required: true, message: '请选择供应商名称', trigger: 'change'}],
          product_sale_name: [{required: true, message: '请选择商品名称', trigger: 'blur'}],
          supplier_product_name: [{required: true, message: '请选择商品销售名称', trigger: 'change'}],
          supplier_price: [{required: true, message: '请选择供货价', trigger: 'change'}],
          seller_supplier_id: [{required: true, message: '请选择供应商名称', trigger: 'change'}],
          seq: [{ required: true, validator: validateNum, trigger: 'blur' }],
          activity_area_sale_price: this.activityAreaSalePriceRules,
          is_self_supporting: [{required: true, message: '请选择是否自负盈亏', trigger: 'change'}]
        },
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        productpageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        productpageparm1: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        isCanSubmit: true,
        typeList: [{
          name:'自营',
          value: 0
        }, {
          name:'供应商',
          value: 1
        }],
        isselfList: [{
          name:'是',
          value: 1
        }, {
          name:'否',
          value: 0
        }],
        tionList: [],
        supplierList: [],
        activity_area_id: '',
        sale_id: '',
        issureRonous: false,
        issureRonousgys: false,
        labelCurrentPage: 1,
        labelPagesize: 10,
        labelTotalSize: 0,
        sortName: '',
        selectedLabelName: '',
        small: true,
        activity_zone_id: '',
        sortId: '',
        saleId: '',
        sellerPurchaserId: '',
        sellerSupplierId: '',
        selectedProduct: '',
        isDisabled: false,
        importWas: false,
        totalFail: false,
        importFailed: false,
        resultsDialogVisible: false,
        batchlistData: [],
        resultslistData: [],
        excelFileData: '',
        total_fail: '',
        total_success: '',
        batchpageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        listFormInline: {
          page: 1,
          rows: 10,
          fileId: '',
          activityAreaId: ''
        },
        summaryFormInline: {
          page: 1,
          rows: 10,
          fileId: "",
          activityAreaId: ''
        },
        resultsPageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        stuads: false
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline);
      this.id = this.$route.query.id;
      if (this.$route.query.id) {
        localStorage.setItem('activity_area_id', this.$route.query.id)
      }
    },
    mounted() {
      if (!this.id) {
        this.id = localStorage.getItem('activity_area_id')
      }
      this.formInline.activity_area_id = this.id;
    },
    computed: {
      activityAreaSalePriceRules() {
        if (this.flashForm.product_type === 0) {
          return [];
        } else {
          return {
            validator: (rule, value, callback) => {
              if (value === '' || value == undefined || value == null) {
                return callback(new Error('请输入专区销售价'));
              } else if (value <= this.selectedProduct.supplier_price) {
                return callback(new Error('专区销售价不能小于等于供货价'));
              } else {
                return callback();
              }
            },
            trigger: 'blur'
          };
        }
      }
    },
    methods: {
      // 获取公司列表
      getdata(parameter) {
        this.loading = true
        itemsList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.content.rows
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.rows
              this.pageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.rows = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.formInline.page = 1;
        this.getdata(this.formInline)
      },
      // 新增商城商品
      adddiscount() {
        this.infoDialogVisible = true;
        this.dialogTitle = '新增商城商品';
        this.selectedLabelName = '';
        this.flashForm = {
          id: "",
          activity_area_id: "",
          activity_area_sort_id: "",
          seq: "",
          sale_name: "",
          sale_id: "",
          zone_sale_name: "",
          activity_area_code: "",
          activity_area_sale_price: "",
          product_type: 0,
          seller_name: "",
          product_sale_name: "",
          seller_supplier_id: "",
          supplier_product_name: "",
          supplier_price: "",
          is_self_supporting: "",
          seller_supplier_product_id: ""
        };
        this.isDisabled = false;
        this.getLabel();
        this.getSupplier(this.sellerSupplierId)
      },
      // 修改-专属商城
      editdiscount() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        this.dialogTitle = '修改专属商城';
        this.infoDialogVisible = true;
        this.productId = this.selectTableData[0].id;
        this.selectedLabelName = this.selectTableData[0].activity_area_sort_name;
        this.flashForm.product_type = this.selectTableData[0].product_type;
        this.isDisabled = true;
        this.getSupplier(this.sellerSupplierId);
        this.detail(this.selectTableData[0].id);
        this.getLabel(this.selectTableData[0].activity_area_sort_name);
      },
      detail(id) {
        this.loading = true
        itemsDetail(id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if(res.content) {
                this.flashForm = res.content;
                this.saleId = res.content.sale_id;
                this.sellerPurchaserId = res.content.sale_id;
                this.flashForm.sale_id = res.content.product_sale_name;
                this.flashForm.supplier_product_name = res.content.product_sale_name;
                this.flashForm.supplier_price = res.content.supplier_price;
                this.sortId = this.flashForm.activity_area_sort_id;
                this.flashForm.activity_area_sort_id = res.content.activity_area_sort_id;
                this.sellerSupplierId = res.content.seller_supplier_id;
              }
              this.flashForm.product_type = this.selectTableData[0].product_type;
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 供应商名称
      getSupplier() {
        let param = {
          page: 1,
          rows: 5000,
          seller_supplier_name: "",
          audit_status: 261,
          begin_time: "",
          end_time: ""
        }
        purchaserSupplierList(param)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.supplierList = res.content.rows;
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      changeSendMode() {
        this.flashForm = {
          seq: this.flashForm.seq,
          sale_name: this.flashForm.sale_name,
          activity_area_code: this.flashForm.activity_area_code,
          activity_area_sale_price: '',
          activity_area_sort_id: this.flashForm.activity_area_sort_id,
          product_type: this.flashForm.product_type,
          seller_name: '',
          seller_supplier_id: '',
          supplier_product_name: '',
          supplier_price: '',
          seller_supplier_name: '',
          sale_id: '',
          product_sale_name: '',
          is_self_supporting: ''
        }
        this.sortId = this.flashForm.activity_area_sort_id
        this.$refs.flashForm.validateField('activity_area_sale_price');
      },
      getLabel(sortName) {
        let param = {
          page: this.labelCurrentPage,
          rows: 10,
          area_sort_name: sortName,
          activity_zone_id: this.id
        }
        areaSortList(param)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if (!res.content.rows.length) {
                this.selectedLabelName = ''
              }
              this.tionList = res.content.rows;
              this.labelTotalSize = res.content.total;
              for (let i = 0; i < this.tionList.length; i++) {
                if (this.tionList[i].area_sort_name == sortName) {
                  this.sortId = this.tionList[i].id;
                }
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      remoteMethod(val) {
        this.labelCurrentPage = 1
        this.sortName = val;
        this.getLabel(val)
      },
      focusLabelName() {
        if (!this.selectedLabelName) {
          this.sortName = ''
          this.getLabel('')
        }
      },
      changeLabelName(activity_area_sort_id) {
        this.labelCurrentPage = 1
        this.tionList.forEach((item) => {
          if (item.id == activity_area_sort_id) {
            this.selectedLabelName = item.area_sort_name;
            this.getLabel(item.area_sort_name)
          }
        })
      },
      clear() {
        this.getLabel()
        this.labelCurrentPage = 1
        this.sortName = ''
        this.sortId = ''
      },
      labelHandleSizeChange(val) {
        //console.log(`每页 ${val} 条`);
        this.labelPagesize = val;
        this.getLabel(this.sortName)
      },
      labelHandleCurrentChange(val) {
        //console.log(`当前页: ${val}`);
        this.labelCurrentPage = val;
        this.getLabel(this.sortName)
      },
      // 删除商城分类
      deldiscount() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        const title = '是否删除商城商品？';
        this.$confirm(title, '删除商城商品', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true;
          itemsDelete(this.selectTableData[0].id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      // 专属商城确认
      saveSort(formName) {
        if (!this.id) {
          this.id = localStorage.getItem('activity_area_id')
        }
        this.flashForm.activity_area_id = this.id;
        this.flashForm.activity_area_sort_id = this.sortId;
        if (this.flashForm.product_type == 0) {
          if (this.issureRonous) {
            this.flashForm.sale_id = this.infoSelectTableData[0].sale_id;
          } else {
            this.flashForm.sale_id = this.saleId;
          }
        } else {
          if (this.issureRonousgys) {
            this.flashForm.sale_id = this.infoSelectTableData[0].sale_id;
            this.flashForm.seller_supplier_product_id = this.infoSelectTableData[0].id;
          } else {
            this.flashForm.sale_id = this.sellerPurchaserId;
          }
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.isCanSubmit = false;
            this.loading = true;
            if (this.dialogTitle == '新增商城商品') {
              itemsAdd(this.flashForm)
                .then(res => {
                  this.isCanSubmit = true;
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功增加专属商城商品!'
                    });
                    this.handleClose()
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.isCanSubmit = true;
                  this.loading = false
                  this.$message.error('网络错误，请稍后再试！')
                })
            } else {
              this.flashForm.id = this.productId;
              itemsUpdate(this.flashForm)
                .then(res => {
                  this.isCanSubmit = true;
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功修改专属商城商品!'
                    });
                    this.handleClose()
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.isCanSubmit = true;
                  this.loading = false
                  this.$message.error('网络错误，请稍后再试！')
                })
            }
          } else {
            console.log('error submit!!');
          }
        });
      },
      // 选择商品列表
      getproductdata() {
        this.loading = true
        itemsProductList(this.productFormInline)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.productListData = res.content.rows
              // 分页赋值
              this.productpageparm.currentPage = this.productFormInline.page
              this.productpageparm.pageSize = this.productFormInline.rows
              this.productpageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      productCallFather(parm) {
        this.productFormInline.page = parm.currentPage
        this.productFormInline.rows = parm.pageSize
        this.getproductdata(this.productFormInline.activity_area_sort_id)
      },
      // 查询选择商品弹窗
      querySearch() {
        this.productDialogVisible = true;
        this.productFormInline.activity_area_sort_id = this.id;
        this.getproductdata(this.productFormInline.activity_area_sort_id)
      },
      sureRonous() {
        if (this.infoSelectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.infoSelectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        this.productFormInline = {
          page: 1,
          rows: 10,
          product_code: "",
          sale_id: "",
          sale_name: "",
          activity_area_sort_id: ""
        };
        this.productDialogVisible = false;
        this.issureRonous = true;
      },
      // 搜索事件
      productSearch() {
        this.productFormInline.page = 1;
        this.getproductdata(this.productFormInline)
      },
      handleRemove(file) {
        console.log(file);
      },
      handleSelectionChange(val) {
        this.selectTableData = val;
      },
      infoHandleSelectionChange(val) {
        this.infoSelectTableData = val;
        this.flashForm.product_sale_name = val.map(item => item.sale_name).join(',');
        this.flashForm.sale_id = val.map(item => item.sale_name).join(',');
      },
      handleClose() {
        this.$refs["flashForm"].resetFields();
        this.infoDialogVisible = false;
        this.sortId = '';
        this.saleId = '';
        this.issureRonous = '';
        this.issureRonousgys = ''
      },
      prodHandleClose() {
        this.productFormInline.sale_name = "";
        this.productFormInline.product_code = "";
        this.productDialogVisible = false;
        this.getproductdata()
      },
      // 供应商-选择商品列表
      getproductdata1() {
        this.loading = true
        supplyProductList(this.productFormInline1)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.productListData1 = res.content.rows
              // 分页赋值
              this.productpageparm1.currentPage = this.productFormInline1.page
              this.productpageparm1.pageSize = this.productFormInline1.rows
              this.productpageparm1.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      productCallFather1(parm) {
        this.productFormInline1.page = parm.currentPage
        this.productFormInline1.rows = parm.pageSize
        this.getproductdata1(this.productFormInline1.supplier_seller_id)
      },
      changeProductName() {
        this.$set(this.flashForm, "supplier_product_name", "")
        this.$set(this.flashForm, "supplier_price", "")
      },
      // 查询选择商品弹窗
      supplierSearch() {
        if(!this.flashForm.seller_supplier_id) {
          this.$message.error('供应商名称不能为空！')
          return
        }
        this.productDialogVisible1 = true;
        this.productFormInline1.supplier_seller_id = this.flashForm.seller_supplier_id;
        this.getproductdata1(this.productFormInline1.supplier_seller_id)
      },
      sureRonous1() {
        if (this.infoSelectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.infoSelectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        this.selectedProduct = this.infoSelectTableData[0];
        this.productFormInline1 = {
            page: 1,
            rows: 10,
            product_code: "",
            sale_name: "",
            activity_area_sort_id: "",
            supplier_seller_id: "",
            supplier_price: "",
            status: 1
        },
        this.productDialogVisible1 = false;
        this.issureRonousgys = true
      },
      // 搜索事件
      productSearch1() {
        this.productFormInline1.page = 1;
        this.getproductdata1(this.flashForm.seller_supplier_id)
      },
      infoHandleSelectionChange1(val) {
        this.infoSelectTableData = val;
        this.flashForm.supplier_product_name = val.map(item => item.sale_name).join(',');
        this.flashForm.supplier_price = val.map(item => item.supplier_price).join(',')
      },
      prodHandleClose1() {
        this.productFormInline1.sale_name = "";
        this.productFormInline1.product_code = "";
        this.productDialogVisible1 = false;
        this.getproductdata1()
      },
      // 批量导入商城商品弹窗
      batch() {
        this.batchDialogVisible = true;
        this.listFormInline.activityAreaId = this.id;
        this.getImport(this.listFormInline)
      },
      // 获取导入日志列表
      getImport(parameter) {
        this.loading = true
        batchImportLogsList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.batchlistData = res.content.rows
              // 分页赋值
              this.batchpageparm.currentPage = this.listFormInline.page
              this.batchpageparm.pageSize = this.listFormInline.rows
              this.batchpageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      importFather(parm) {
        this.listFormInline.page = parm.currentPage
        this.listFormInline.rows = parm.pageSize
        this.getImport(this.listFormInline)
      },
      // 关闭批量导入上架信息弹窗
      batchHandleClose(done) {
        this.$refs.excelLoad.clearFiles();
        this.batchDialogVisible = false;
        done()
      },
      // 上传excel文件
      excelBeforeUpload(file) {
        const isExcel = file.type === 'application/vnd.ms-excel' || file.name.endsWith('.xls') || file.name.endsWith('.xlsx');
        if (!isExcel) {
          this.$message({
            message: "请上传excel文件!",
            type: "error",
          });
          return false;
        }
        const fileData = new FormData();
        fileData.append("file", file);
        this.excelFileData = fileData
      },
      // 确认导入
      confirmImport() {
        if (!this.$refs.excelLoad.uploadFiles || this.$refs.excelLoad.uploadFiles.length === 0) {
          this.$message.error('请上传xlsx文件');
          return;
        }
        this.isCanSubmit = false
        this.loading = true
        itemsBatchImport(this.id, this.excelFileData)
          .then(res => {
            this.isCanSubmit = true
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else if (res.code == 0) {
              this.$message({
                type: 'info',
                message: '数据正在进行导入，请稍后查看结果！'
              })
              this.getImport(this.listFormInline)
            } else {
              this.$message({
                type: 'success',
                message: '您已成功导入上架信息'
              });
              this.batchHandleClose();
              this.getdata(this.formInline)
            }
          })
          .catch(err => {
            this.isCanSubmit = true
            this.loading = false
            // this.$message.error('网络错误,请稍后再试!')
          })
      },
      // 下载模版
      download(params) {
        this.loading = true;
        batchExport(params)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              let url = window.URL.createObjectURL(new Blob([res]))
              // 插入一个a标签，隐藏，设置href属性，触发点击方法
              let link = document.createElement('a')
              link.style.display = 'none'
              link.href = url
              link.setAttribute('download', 'activityImportTemp.xlsx')
              document.body.appendChild(link)
              link.click()
              //下载完成后
              document.body.removeChild(link)
              window.URL.revokeObjectURL(url)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 查看结果
      results(file_id, error_message, status, total_fail, total_success) {
        this.summaryFormInline.fileId = file_id;
        this.total_success = total_success;
        this.total_fail = total_fail;
        this.errorMessage = error_message;
        this.statues = status;
        if (this.statues == '1') {
          if (this.total_fail == '0') {
            this.totalFail = true
            this.importWas = false
            this.importFailed = false
          } else {
            this.totalFail = false
            this.importWas = true
            this.importFailed = false
            this.getSummaryList(this.summaryFormInline)
          }
        } else if (this.statues == '2') {
          this.totalFail = false
          this.importWas = false
          this.importFailed = true
        }
        this.resultsDialogVisible = true
      },
      // 导入结果明细汇总列表
      getSummaryList(parameter) {
        this.loading = true
        batchImportLogsDetailList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.resultslistData = res.content.rows
              // 分页赋值
              this.resultsPageparm.currentPage = this.summaryFormInline.page
              this.resultsPageparm.pageSize = this.summaryFormInline.rows
              this.resultsPageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      resultscallFather(parm) {
        this.summaryFormInline.page = parm.currentPage
        this.summaryFormInline.rows = parm.pageSize
        this.getSummaryList(this.summaryFormInline)
      },
      uploadFile(file) {
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.standard_code == cell.innerText || row.seller_name == cell.innerText || row.sale_name == cell.innerText || row.product_code == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      }
    }
  }
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  /deep/ .flashForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .flashForm .el-input {
    width: 320px;
  }

  /deep/ .flashForm .el-input--small {
    width: 320px;
  }

  /deep/ .textarea .el-textarea__inner {
    resize: none;
  }

  /deep/ .flashForm .el-form-item__label {
    position: relative;
    padding: 0 22px 0 0 !important;
  }

  /deep/ .flashForm .el-select-dropdown__list {
    padding-bottom: 50px;
    min-height: 150px;
  }

  /deep/ .flashForm .el-select-dropdown__item {
    width: 320px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  /deep/ .el-dialog--center {
    border-radius: 8px !important;
  }

  /deep/ .el-message-box__title {
    color: #409EFF !important;
  }

  /deep/ .el-dialog__title {
    color: #409EFF !important;
  }

  .pagination-absolute {
    position: absolute;
    bottom: 0;
    background: #fff;
    width: 95%;
    padding-left: 20px;
    height: 40px;
  }

  /deep/ .form-item-with-asterisk .el-form-item__label::before {
    content: '*';
    margin-right: 4px;
    color: red; /* 可以设置星号的颜色 */
  }

  .importtion {
    text-align: center;
    padding: 0 20px 20px;
    font-size: 20px;
  }

  .color409EFF {
    color: #409EFF;
  }

  .colorec808d {
    color: #ec808d;
  }

  .colord9001b {
    color: #d9001b;
  }

  .resultent {
    font-size: 20px;
    color: #d9001b;
    margin: 0 0 50px;
  }

  .zipFile {
    display: flex;
    align-items: center;
    margin-left: 20%;
  }

  .icon-container {
    position: relative;
    display: inline-block;
  }

  .icon-container i {
    font-size: 24px;
    position: relative;
  }

  .icon-container i::after {
    content: "上传excel文件";
    width: 100%;
    position: absolute;
    top: 70%;
    left: 50%;
    transform: translateX(-50%);
    font-size: 12px;
    line-height: 12px;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
    border: 1px dashed #DCDFE6;
  }

  .textCenter {
    text-align: center;
  }

  .importLog {
    font-size: 16px;
    color: #555555;
    font-weight: 700;
    margin: 10px 0;
  }
</style>





// WEBPACK FOOTER //
// src/views/store/productsGaining.vue